export const arrayUnique = <T>(array: T[]): T[] => {
    return [...new Set(array)]
}

export const errorHasPayload = (error: unknown): error is { payload: Record<string, unknown> } => {
    return !!(error as { payload: Record<string, unknown> }).payload
}

export const errorHasMessage = (error: unknown): error is { message: string } => {
    return !!(error as { message: string }).message
}

/**
 * Round minutes to the nearest 5 or 0
 */
export const roundMinutesToNearest5Or0 = (date: Date): Date => {
    const roundedDate = new Date(date)
    const minutes = roundedDate.getMinutes()
    const remainder = minutes % 5

    if (remainder !== 0) {
        // Round up to the next 5 or 0
        roundedDate.setMinutes(minutes + (5 - remainder))
        // Reset seconds and milliseconds
        roundedDate.setSeconds(0, 0)
    }

    return roundedDate
}
